module.exports = __webpack_public_path__ + "static/img/4.b66683c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/eng/4.png
// module id = aKGA
// module chunks = 0